// src/components/RtsSlipDownloadIcon/RtsSlipDownloadIcon.jsx

import React, { useState } from 'react';
import { Tooltip, notification } from 'antd';
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_URL } from '../../constants/config';
import { getAuthData } from '../../helpers/authStorage';
import { getUserTenant } from '../../helpers/authStorage';

function RtsSlipDownloadIcon({ orderId }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const { accessToken } = getAuthData();
      const tenant = getUserTenant();

      const response = await axios.get(
        `${API_URL}/admin/orders/${orderId}/rts-slip`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Tenant: tenant,
          },
        }
      );

      const url = response?.data?.url;
      if (url) {
        window.open(url, '_blank');
      } else {
        notification.warning({
          message: 'No slip found',
          description: 'RTS slip has not been generated yet for this order.',
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to load RTS slip.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Download RTS Slip">
      <span
        onClick={handleClick}
        style={{ cursor: 'pointer', fontSize: 20, color: '#1890ff' }}
      >
        {loading ? <LoadingOutlined /> : <DownloadOutlined />}
      </span>
    </Tooltip>
  );
}

export default RtsSlipDownloadIcon;